import React, { useState } from 'react';
import { isBefore } from 'date-fns';

import CoachingScheduleUpcomingSessions from './CoachingScheduleUpcomingSessions';
import CoachingScheduleDateHeader from './CoachingScheduleDateHeader';
import { getWeeklyTimeframe } from 'coaching/lib/timeIntervals';
import CenteredLoadingIndicator from 'components/CenteredLoadingIndicator';
import GetCoachingScheduleContainer from 'coaching/containers/GetCoachingScheduleContainer';
import ErrorReporter from 'app/components/ErrorReporter';
import Notice from 'components/Notice';
import Row from 'components/Row';
import Text from 'components/Text';
import { Holiday2021Banner } from 'coaching/components/Banners';

import EventTracking from 'lib/EventTracking';
import { coachDashboardPrefix } from 'coaching/components/CoachDashboard';

export default function CoachingScheduleView() {
  const [weekOffset, setWeekOffset] = useState<number>(0);
  const { startDateTime, endDateTime } = getWeeklyTimeframe(weekOffset);
  const startDateTimeString = startDateTime.toISOString();
  const endDateTimeString = endDateTime.toISOString();
  // This banner is for Christmas & New Years' 2021-2022, so hide it after the 1st
  const shouldShowBanner = isBefore(new Date(), '2022-01-02');

  const renderError = () => {
    return (
      <ErrorReporter error="Coaching - couldn't load data">
        <Text align="center">
          <Notice color="whiteout">
            Sorry—no data is available at this time. Try refreshing the page.
          </Notice>
        </Text>
      </ErrorReporter>
    );
  };

  return (
    <React.Fragment>
      {shouldShowBanner && (
        <Row>
          <Holiday2021Banner />
        </Row>
      )}
      <GetCoachingScheduleContainer
        startDateTime={startDateTimeString}
        endDateTime={endDateTimeString}>
        {({ loading, error, coachingDashboardScheduleInstances }) => {
          if (loading) {
            return <CenteredLoadingIndicator data-test="centered-loading" />;
          }

          if (error) {
            console.error(error);
            return renderError();
          }

          return (
            <div data-test="coaching-schedule-view">
              <CoachingScheduleDateHeader
                onWeekForward={() => {
                  setWeekOffset(prev => prev + 1);
                  EventTracking.trackKey(
                    `${coachDashboardPrefix}.coach_dashboard_schedule.week_date_picker_next_week.click`
                  );
                }}
                onWeekBack={() => setWeekOffset(prev => prev - 1)}
                weekOffset={weekOffset}
                startDateTime={startDateTimeString}
                endDateTime={endDateTimeString}
              />
              <CoachingScheduleUpcomingSessions
                weekOffset={weekOffset}
                instances={coachingDashboardScheduleInstances}
              />
            </div>
          );
        }}
      </GetCoachingScheduleContainer>
    </React.Fragment>
  );
}
